import { render, staticRenderFns } from "./ChannelBreakdown.vue?vue&type=template&id=71451baa&scoped=true"
import script from "./ChannelBreakdown.vue?vue&type=script&lang=js"
export * from "./ChannelBreakdown.vue?vue&type=script&lang=js"
import style0 from "./ChannelBreakdown.vue?vue&type=style&index=0&id=71451baa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71451baa",
  null
  
)

export default component.exports